import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@/components/controls/Tabs";
import { FieldManagementTab as EntityFieldManagementTab } from "@/pages/settings/components/dealsSettings/FieldManagement/FieldManagementTab";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { useFeatureFlag } from "@/services/features/hook";
import { FeatureFlags } from "@/services/features/types";
import { useEnablePartnerships } from "@/pages/partners/hooks";

const TRANSLATION_KEY = "settings.people.fieldManagementTab";

const ENTITY_BY_TAB: Record<string, EntityType> = {
  person: EntityType.PERSON,
  partner: EntityType.PARTNER_CONTACT
};

export const FieldManagementTab: React.FC = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<string>("person");
  const { enabled: partnerContactsFlag } = useFeatureFlag(
    FeatureFlags.CRM_8228_PARTNER_CONTACTS_TABLE
  );
  const enablePartnerships = useEnablePartnerships();
  const showPartnerContacts = partnerContactsFlag && enablePartnerships;

  if (!showPartnerContacts) {
    return <EntityFieldManagementTab entityType={EntityType.PERSON} />;
  }

  const toggleOptions: Record<string, string> = {
    person: t(`${TRANSLATION_KEY}.toggle.person`),
    partner: t(`${TRANSLATION_KEY}.toggle.partner`)
  };

  return (
    <div className="flex w-full flex-col gap-4">
      <Tabs
        options={toggleOptions}
        value={tab}
        valueSelected={setTab}
        size="lg"
        containerClassName="w-fit"
        dataTest="people-field-management-entity-toggle"
      />
      <EntityFieldManagementTab key={tab} entityType={ENTITY_BY_TAB[tab]} />
    </div>
  );
};
